import { useUserEventLogger } from '@repo/tracking-service';
import { useAuthContext } from '@repo/user-session';
import { Dispatch, SetStateAction, useCallback, useEffect, useState } from 'react';

import { ReasonDrawer } from '@/components/auth/withdraw/ReasonDrawer';
import { WithdrawalReason } from '@/lib/types/auth';
import ExpandIcon from '@/public/images/survey/ic-expand-more.svg';

interface Props {
  title: string;
  setSelectedReason: Dispatch<SetStateAction<WithdrawalReason | null>>;
}

export const ReasonSelectInput = ({ title, setSelectedReason }: Props) => {
  const { authService } = useAuthContext();
  const [isOpenDrawer, setOpenDrawer] = useState(false);
  const { sendClickEvent } = useUserEventLogger();
  const [activeReasons, setActiveReasons] = useState<WithdrawalReason[] | null>(null);

  const getReasons = useCallback(async () => {
    if (!authService) return;
    const response = await authService?.signService.getWithdrawReasons();

    if (!response?.ok) return;
    const { data } = await response.json();
    const reasons = data.filter((reason: WithdrawalReason) => reason.active).sort((a: WithdrawalReason, b: WithdrawalReason) => a.sequence - b.sequence);

    setActiveReasons(reasons);
  }, [authService]);

  useEffect(() => {
    getReasons();
  }, [getReasons]);

  return (
    <>
      <button
        type={'button'}
        className={'pl-4 pr-2 rounded-2.5 border border-gray-200 w-full h-12 flex items-center text-left gap-2'}
        onClick={() => {
          sendClickEvent('feedback-delete_body_reason-select');
          setOpenDrawer(true);
        }}
      >
        <span className={'sub-title-16 text-gray-800 flex-1'}>{title}</span>
        <span className={'inline-flex shrink-0'}>
          <ExpandIcon className={'text-gray-500'} />
        </span>
      </button>
      {activeReasons && activeReasons.length > 0 && (
        <ReasonDrawer
          isVisible={isOpenDrawer}
          onClose={() => setOpenDrawer(false)}
          list={activeReasons}
          onClickReason={(reason) => {
            setSelectedReason(reason);
            setOpenDrawer(false);
          }}
        />
      )}
    </>
  );
};
